import { IFolder } from "store/types";
import { ClientDetail, IClientDetailCharacteristic } from "store/types/client";
import { useContextSelector } from "use-context-selector";

import { IStore, StoreContext } from "../../store-context";

export const useClientSelector = (): ClientDetail | null =>
  useContextSelector(StoreContext, (store: IStore) => store.clientModule.client);

export const useClientIdSelector = (): number | undefined =>
  useContextSelector(StoreContext, (store: IStore) => store.clientModule.client?.id);

export const useClientWorkspaceFoldersSelector = (): Record<number, IFolder> =>
  useContextSelector(StoreContext, (store: IStore) => store.clientModule.workspaceFolders);

export const useClientCharacteristicsSelector = (): IClientDetailCharacteristic[] =>
  useContextSelector(StoreContext, (store: IStore) => store.clientModule.client?.characteristics ?? []);
